import React from 'react';

import MenuItem from '../../components/MenuItem';
import useModalDispatch from '../../hooks/useModalDispatch';
import DeleteResourceModal, { DestroyResourceModalProps } from '../../modals/DeleteResourceModal';

const DestroyMenuItem = ({ icon, ...props }: DestroyResourceModalProps & { icon?: string }) => {
  const openModal = useModalDispatch(DeleteResourceModal);

  return (
    <MenuItem
      href="#"
      icon={icon ?? 'trash-o'}
      onClick={(e) => {
        e.preventDefault();
        openModal(props!);
      }}
    >
      {props.label ?? 'Verwijderen'}
    </MenuItem>
  );
};

export default DestroyMenuItem;
